/**
 * Formateo compartido para inputs de montos en pesos: separador de miles en vivo mientras se
 * escribe, para que un cero de más (o de menos) salte a la vista en montos de varios millones.
 * Usado por InputMonto (Bootstrap) e InputMontoMui (Material UI) para que ambos se comporten igual.
 */

export function formatearMonto(valor) {
    if (valor === '' || valor === null || valor === undefined) return '';
    const numero = Number(valor);
    return Number.isNaN(numero) ? '' : numero.toLocaleString('es-AR');
}

export function parsearMontoDesdeTexto(texto) {
    const soloDigitos = texto.replace(/\D/g, '');
    return soloDigitos === '' ? '' : Number(soloDigitos);
}
